module.exports = __webpack_public_path__ + "media/components/chat/crossing-fd134f480d08b5ecd4464d82f1566085.svg";